<rid-demo-page [title]="'Demo'">
  <rid-button class="w-full" content="Oefenvormen" variant="PRIMARY" routerLink="/mechanics" />
  <rid-button class="w-full" content="Component Lab" variant="SECONDARY" routerLink="/component-lab" />
</rid-demo-page>
